import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import logo from '../../assets/images/mereos-logo-with-text.svg';
import { useTranslation } from 'react-i18next';
import './header.scss';
import caretIcon from '../../assets/images/carot-down.svg';
import hamburgerIcon from '../../assets/images/hamburger.svg';
import closeIcon from '../../assets/images/close-icon.svg';

const Header = () => {
	let { t, i18n } = useTranslation();
	const [defaultLangauge, setDefaultLangauge] = useState({});
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const languages = [
		{
			name: 'french',
			langCode: 'fr',
			img: "https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-france-round.svg"
		},
		{
			name: 'english_uk',
			langCode: 'en',
			img: "https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-uk-round.svg"
		},
		{
			name: 'spanish',
			img: "https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-spain-round.svg",
			langCode: 'es'
		},
		{
			name: 'italian',
			img: `https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-italy-round.svg`,
			langCode: 'it'
		},
		{
			name: 'portuguese_brazil',
			img: `https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-brazil-round.svg`,
			langCode: 'pt'
		},
		{
			name: 'german',
			img: `https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-germany-round.svg`,
			langCode: 'de'
		},
		{
			name: 'dutch',
			img: `https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-netherlands-round.svg`,
			langCode: 'nl'
		},
		{
			name: 'welsh',
			langCode: 'cy',
			img: 'https://mereos-corder.s3.eu-west-3.amazonaws.com/library_icons/flag-of-whales-round.svg',
		},
	];

	useEffect(() => {
		const selectedLanguage = languages.filter(language => language.langCode.includes(i18n.language));
		if (selectedLanguage && selectedLanguage.length) {
			setDefaultLangauge({ ...selectedLanguage[0] });
		} else {
			setDefaultLangauge({ ...languages[0] });
		}
	}, [i18n.language]);

	const handleLanguageChange = (e, language) => {
		e.stopPropagation();
		e.preventDefault();
		i18n.changeLanguage(language.langCode);
		setDefaultLangauge(language);
	};

	return (
		<>
			<header className='header-container'>
				<div className='header-content'>
					<Link to="/" className="logo-container">
						<img alt="header" src={logo} />
					</Link>

					<button
						className="hamburger-menu"
						onClick={() => setIsMenuOpen(!isMenuOpen)}
						aria-label="Toggle navigation"
					>
						<img src={isMenuOpen ? closeIcon : hamburgerIcon} alt="Menu icon" />
					</button>

					<nav className={`header-nav ${isMenuOpen ? 'open' : ''}`}>
						<div className="header-nav-dropdown">
							<Link to="/" className='dropdown-nav-text'>
								<p>{t('get_started')}</p>
							</Link>
						</div>
						<div className="header-nav-dropdown">
							<Link to="/compatibility/browser" className='dropdown-nav-text'>
								<p>{t('compatibility')}</p>
								<img src={caretIcon} alt="Dropdown icon" />
							</Link>
							<div className="nav-dropdown-menu">
								<Link to="/compatibility/browser">{t('browser')}</Link>
								<Link to="/compatibility/system">{t('system')}</Link>
							</div>
						</div>
						<div className="header-nav-dropdown">
							<Link to="/features" className='dropdown-nav-text'>
								<p>{t('feature')}</p>
								<img src={caretIcon} alt="Dropdown icon" />
							</Link>
							<div className="nav-dropdown-menu">
								<Link to="/features/ai">AI</Link>
								<Link to="/features/lockdown">{t('lock_down')}</Link>
								<Link to="/features/recording">{t('recording')}</Link>
								<Link to="/features/verification">{t('verification')}</Link>
								<Link to="/features/quiz-tools">{t('quiz_tools')}</Link>
								<Link to="/features/system">{t('system')}</Link>
							</div>
						</div>

						<div className="header-nav-dropdown">
							<Link to="/documentation/exceptions" className='dropdown-nav-text'>
								<p>{t('documentation')}</p>
								<img src={caretIcon} alt="Dropdown icon" />
							</Link>
							<div className="nav-dropdown-menu">
								<Link to="/documentation/exceptions">{t('exceptions')}</Link>
								<Link to="/documentation/dashboard-api">{t('api_documentation')}</Link>
								<Link to="/documentation/microsoft-sso-integration">{t('microsoft_sso_integration')}</Link>
							</div>
						</div>
					</nav>

					<div className="language-selector">
						<div className="group">
							<div className="dropdown">
								{defaultLangauge && (
									<img
										alt={defaultLangauge.name}
										src={defaultLangauge.img}
										className="default-language"
										title={defaultLangauge.name}
									/>
								)}
								<img
									alt="arrow-down"
									src="https://d2lxkizvrhu4im.cloudfront.net/icons/arrow-down_yellow_light_icon.svg.svg"
									className="arrow-icon"
								/>
							</div>
							<div className="menu">
								<div className="menu-items">
									{languages.map((lang, index) =>
										lang.langCode !== defaultLangauge.langCode ? (
											<img
												key={index}
												alt={lang.name}
												src={lang.img}
												className="language-option"
												title={t(lang.name)}
												onClick={(e) => handleLanguageChange(e, lang)}
											/>
										) : null
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
		</>
	);
};

export default Header;
